var _circle, _path, _path2, _path3, _g, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWritewizLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#6A097D"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16848_229)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.9513 23.3242H53.97L48.1462 42.9621L42.1863 23.3242H32.8809L37.5004 38.3578L42.9902 58.3352H53.0996L64.9513 23.3242Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1442 42.9591L42.1859 23.3242H32.8789L37.4999 38.3578L42.9898 58.3352H53.0992L48.1442 42.9591Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0488 23.3242L21.8325 58.3352H31.9419L37.4998 38.3578L42.1858 23.3242H32.8803L26.854 42.9621L21.0286 23.3242H10.0488Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0159 42.432L26.8542 42.9601L26.6638 42.3209L14.4902 36.5156L21.8328 58.3332H31.9421L35.386 45.9541L27.0159 42.432Z",
    fill: "url(#paint0_linear_16848_229)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0352 47.5742L42.9909 58.3323H53.1003L54.4935 54.2196L40.0352 47.5742Z",
    fill: "url(#paint1_linear_16848_229)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9705 23.5027C58.5988 24.7246 57.7957 25.767 56.7129 26.4331C55.6301 27.0991 54.3426 27.3426 53.0937 27.1177C52.8942 27.0827 52.858 27.0796 52.8504 27.1177C52.8429 27.1557 52.8837 27.1664 53.1421 27.2516C54.3689 27.6427 55.404 28.4858 56.0404 29.6124C56.654 30.679 56.8715 31.9305 56.6539 33.1436C56.6146 33.3658 56.6131 33.4008 56.6448 33.41C56.6766 33.4191 56.6902 33.3871 56.7506 33.1923C57.1146 31.9763 57.9061 30.9356 58.977 30.2651C60.0479 29.5946 61.3248 29.3404 62.5684 29.55C62.8238 29.5895 62.8707 29.5911 62.8707 29.5606C62.8707 29.5302 62.8465 29.515 62.6546 29.4541C61.4432 29.0777 60.4101 28.2685 59.7494 27.1787C59.0888 26.0889 58.8462 24.7936 59.0672 23.5362C59.1019 23.3353 59.1034 23.3018 59.0672 23.2942C59.0309 23.2866 59.0264 23.3094 58.9705 23.5027Z",
    fill: "#6A097D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16848_229",
    x1: 14.6434,
    y1: 47.4244,
    x2: 35.5858,
    y2: 47.4244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16848_229",
    x1: 40.2454,
    y1: 52.9533,
    x2: 54.7358,
    y2: 52.9533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16848_229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.902,
    height: 35.049,
    fill: "white",
    transform: "translate(10.0488 23.2852)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritewizLogo);
export default __webpack_public_path__ + "static/media/Writewiz-Logo.fa8ab181a5f81a1c6b39316c350a3b14.svg";
export { ForwardRef as ReactComponent };